import { whatIfOrDefaultSelector, whatIfInnerSelector } from '../../../WhatIfsSelector';

export const yearOptions = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);

  const whatIfOptions = whatIf.Options || {};

  return (whatIfOptions.YearsOptions || []).map(y => ({
    value: y,
    label: y.toString(),
  }));
};

export const selectedYear = (state, props) =>
  whatIfInnerSelector(state, props).Year;
